module.exports = __webpack_public_path__ + "media/images/flags/16/Thailand-ffdb3be5e3054e0a0558a56094d55a31.png";